import {lookupCourse} from 'constants/url';
import {useUtilInformation} from '../../../components/hooks/index';
import axios from 'axios';

async function useLoadLookupCourse() {
  const {token, cwid, role} = useUtilInformation();
  try {
    const response = await axios.get(
      `${lookupCourse}?role=${role}&cwid=${cwid}`,
      {
        headers: {Authorization: `Bearer ${token}`},
      },
    );
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupCourse;
